import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { mantenimientoService } from "../services/mantenimiento";

const MESES = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];

function formatFechaTs(ts) {
    if (!ts) return '—';
    const d = new Date(ts);
    return `${d.getDate()} ${MESES[d.getMonth()]} ${d.getFullYear()}`;
}
function formatKm(km) {
    return km != null ? km.toLocaleString('es-PE') + ' km' : '—';
}
function calcDias(fechaStr) {
    if (!fechaStr) return null;
    const hoy = new Date(); hoy.setHours(0,0,0,0);
    const f   = new Date(fechaStr); f.setHours(0,0,0,0);
    return Math.round((f - hoy) / 86400000);
}
function formatDias(d) {
    if (d == null) return '—';
    if (d === 0) return 'Hoy';
    return d > 0 ? `${d} día${d !== 1 ? 's' : ''}` : `Vencido hace ${Math.abs(d)} día${Math.abs(d) !== 1 ? 's' : ''}`;
}

function statusFromKm(restantes, tolerancia) {
    if (restantes <= 0) return 'vencido';
    if (tolerancia != null && restantes <= tolerancia) return 'proximo';
    return 'aldia';
}
function statusFromDias(dias, tolerancia) {
    if (dias == null) return null;
    if (dias <= 0) return 'vencido';
    if (tolerancia != null && dias <= tolerancia) return 'proximo';
    return 'aldia';
}
const STATUS = {
    aldia:   { bg: '#dcfce7', color: '#15803d', label: 'Al día',           icon: 'bi-check-circle-fill' },
    proximo: { bg: '#fef9c3', color: '#b45309', label: 'Próximo a vencer', icon: 'bi-exclamation-circle-fill' },
    vencido: { bg: '#fee2e2', color: '#b91c1c', label: 'Vencido',          icon: 'bi-x-circle-fill' },
};

function tipoClass(ctipo) {
    return ctipo?.toUpperCase().includes('CORRECTIVO') ? 'correctivo' : 'preventivo';
}
function tipoIcon(ctipo) {
    return ctipo?.toUpperCase().includes('CORRECTIVO') ? 'bi-exclamation-triangle-fill' : 'bi-tools';
}
function estadoCfg(cestado) {
    if (!cestado) return { bg: '#f1f5f9', color: '#64748b' };
    const e = cestado.toUpperCase();
    if (e.includes('CERRAD'))  return { bg: '#dcfce7', color: '#15803d' };
    if (e.includes('PROCESO')) return { bg: '#dbeafe', color: '#1d4ed8' };
    if (e.includes('BACKLOG')) return { bg: '#fef9c3', color: '#b45309' };
    return { bg: '#f1f5f9', color: '#64748b' };
}

const InfoRow = ({ lbl, val, valStyle }) => (
    <div className="mnt-irow">
        <span className="mnt-irow-lbl">{lbl}</span>
        <span className="mnt-irow-val" style={valStyle}>{val}</span>
    </div>
);

const CardSpin = () => (
    <div style={{ textAlign:'center', padding:'2.5rem 0' }}>
        <div className="mnt-spin"></div>
        <p style={{ fontSize:'.78rem', color:'#475569', margin:'.65rem 0 0' }}>Cargando...</p>
    </div>
);

const EmptyState = ({ icon = 'bi-inbox', msg }) => (
    <div style={{ textAlign:'center', padding:'2.5rem 1rem', color:'#475569' }}>
        <i className={`bi ${icon}`} style={{ fontSize:'1.75rem', display:'block', marginBottom:'.5rem' }}></i>
        <p style={{ fontSize:'.83rem', margin:0, lineHeight:1.5 }}>{msg}</p>
    </div>
);

const StatusBadge = ({ status }) => {
    if (!status) return null;
    const s = STATUS[status];
    return (
        <span className="mnt-badge" style={{ background: s.bg, color: s.color, border:`1px solid ${s.color}33` }}>
            <i className={`bi ${s.icon}`} style={{ marginRight:'.3rem' }}></i>{s.label}
        </span>
    );
};

const MetricBlock = ({ value, label, color }) => (
    <div style={{ textAlign:'center', padding:'.75rem 0 1.1rem', borderBottom:'1px solid #f1f5f9', marginBottom:'.85rem' }}>
        <div style={{ fontSize:'1.65rem', fontWeight:800, letterSpacing:'-.03em', color, lineHeight:1 }}>{value}</div>
        <div style={{ fontSize:'.73rem', color:'#475569', marginTop:'.3rem' }}>{label}</div>
    </div>
);

export function Mantenimiento() {
    const [params] = useSearchParams();
    const idactivo = params.get('idactivo') ?? '';
    const tipo     = params.get('tipo')     ?? '';
    const codigo   = params.get('codigo')   ?? '';
    const placa    = params.get('placa')    ?? '';

    const [resumen,   setResumen]   = useState(undefined);
    const [historial, setHistorial] = useState(undefined);

    useEffect(() => {
        mantenimientoService.getResumenXPlaca(placa)
            .then(data => setResumen(data))
            .catch(() => setResumen(null));

        mantenimientoService.getUltimosMantenimientos(placa)
            .then(res => {
                if (!res) { setHistorial(null); return; }
                const arr = Array.isArray(res) ? res : (res.data ?? res.mantenimientos ?? []);
                setHistorial(arr);
            })
            .catch(() => setHistorial(null));
    }, []);

    const volverUrl = `/activo/resumen/?idactivo=${idactivo}&tipo=${tipo}&codigo=${codigo}&placa=${placa}`;
    const unidad    = resumen ?? null;

    return (
        <div className="mnt-page">
            <style>{`
                .mnt-page {
                    max-width: 1100px; margin: 0 auto;
                    padding: 1.5rem 1rem 4rem;
                    background: #f8fafc; min-height: 100vh;
                }
                @media (min-width: 768px) { .mnt-page { padding: 2rem 2rem 4rem; } }

                /* Header */
                .mnt-header { display:flex; align-items:flex-start; gap:1rem; margin-bottom:2rem; flex-wrap:wrap; }
                .mnt-back {
                    display:inline-flex; align-items:center; gap:.35rem; flex-shrink:0;
                    color:#64748b; text-decoration:none; font-size:.82rem; font-weight:500;
                    background:#fff; border:1px solid #e2e8f0; border-radius:.5rem; padding:.45rem .9rem;
                    transition:color .15s, border-color .15s, box-shadow .15s;
                }
                .mnt-back:hover { color:#c81e22; border-color:#fecaca; box-shadow:0 1px 4px rgba(200,30,34,.1); }
                .mnt-title { margin:0; font-size:1.5rem; font-weight:800; color:#0f172a; letter-spacing:-.025em; line-height:1.2; }
                .mnt-subtitle { font-size:.82rem; color:#334155; margin:.2rem 0 0; }
                .mnt-placa {
                    display:inline-flex; align-items:center; gap:.3rem; margin-top:.45rem;
                    background:#fdf2f2; color:#c81e22; border:1px solid #fecaca;
                    font-size:.68rem; font-weight:700; letter-spacing:.07em; text-transform:uppercase;
                    padding:.28rem .75rem; border-radius:.4rem;
                }

                /* Grid */
                .mnt-grid {
                    display:grid; grid-template-columns:1fr;
                    gap:1.25rem; margin-bottom:1.25rem; align-items:start;
                }
                @media (min-width: 768px) { .mnt-grid { grid-template-columns:300px 1fr; gap:1.5rem; } }

                /* Cards */
                .mnt-card {
                    background:#fff; border-radius:1rem; overflow:hidden;
                    border:1px solid #e2e8f0;
                    box-shadow:0 1px 3px rgba(0,0,0,.05), 0 4px 16px rgba(0,0,0,.04);
                }
                .mnt-card-hdr {
                    display:flex; align-items:center; gap:.75rem; flex-wrap:wrap;
                    padding:1.1rem 1.5rem; background:#fafafa; border-bottom:1px solid #f1f5f9;
                }
                .mnt-card-icon {
                    width:34px; height:34px; border-radius:.5rem; flex-shrink:0;
                    display:flex; align-items:center; justify-content:center;
                }
                .mnt-card-title { font-weight:700; font-size:.92rem; color:#0f172a; }
                .mnt-card-body { padding:1.35rem 1.5rem; }

                /* Info rows */
                .mnt-irow {
                    display:flex; justify-content:space-between; align-items:baseline;
                    padding:.5rem 0; border-bottom:1px solid #f8fafc; gap:.5rem;
                }
                .mnt-irow:last-child { border-bottom:none; }
                .mnt-irow-lbl { font-size:.78rem; color:#334155; flex-shrink:0; }
                .mnt-irow-val { font-size:.85rem; font-weight:600; color:#0f172a; text-align:right; }

                /* Section label */
                .mnt-section-lbl {
                    font-size:.67rem; font-weight:700; letter-spacing:.09em;
                    text-transform:uppercase; color:#475569;
                }

                /* Badges */
                .mnt-badge {
                    display:inline-flex; align-items:center;
                    font-size:.65rem; font-weight:700; letter-spacing:.05em;
                    text-transform:uppercase; padding:.22rem .65rem; border-radius:100px;
                }
                .mnt-badge-prev { background:#fdf2f2; color:#c81e22; border:1px solid #fecaca; }
                .mnt-badge-corr { background:#fff1f2; color:#b91c1c; border:1px solid #fecaca; }
                .mnt-badge-back { background:#fef9c3; color:#b45309; border:1px solid #fde68a; }

                /* Timeline */
                .mnt-timeline { position:relative; }
                .mnt-tl-line {
                    position:absolute; left:15px; top:10px; bottom:10px;
                    width:2px; background:#f1f5f9; z-index:0;
                }
                .mnt-tl-item { display:flex; gap:1rem; margin-bottom:1rem; position:relative; z-index:1; }
                .mnt-tl-item:last-child { margin-bottom:0; }
                .mnt-tl-dot {
                    width:32px; height:32px; border-radius:50%; flex-shrink:0;
                    display:flex; align-items:center; justify-content:center;
                    border:2px solid; margin-top:.15rem;
                }
                .mnt-tl-dot.prev { background:#fdf2f2; border-color:#fecaca; }
                .mnt-tl-dot.corr { background:#fff1f2; border-color:#fecaca; }

                /* OT cards */
                .mnt-ot {
                    flex:1; background:#fff; border-radius:.875rem;
                    border:1px solid #e2e8f0; overflow:hidden;
                    box-shadow:0 1px 2px rgba(0,0,0,.04);
                    display:flex; flex-direction:column;
                }
                .mnt-ot-hdr {
                    display:flex; justify-content:space-between; align-items:flex-start;
                    gap:.75rem; padding:.8rem 1rem;
                    background:#fafafa; border-bottom:1px solid #f1f5f9;
                }
                .mnt-ot-hdr-left { display:flex; flex-direction:column; gap:.3rem; min-width:0; }
                .mnt-ot-id-num {
                    font-size:.82rem; font-weight:800; color:#0f172a; letter-spacing:-.01em;
                }
                .mnt-ot-badges { display:flex; gap:.3rem; flex-wrap:wrap; align-items:center; }
                .mnt-ot-fecha-hdr {
                    display:flex; align-items:center; gap:.28rem;
                    font-size:.76rem; font-weight:600; color:#334155;
                    flex-shrink:0; white-space:nowrap; padding-top:.1rem;
                }
                .mnt-ot-body {
                    padding:.7rem 1rem; display:flex; flex-direction:column; gap:.28rem;
                    border-bottom:1px solid #f8fafc;
                }
                .mnt-ot-act { margin:0; font-size:.84rem; font-weight:600; color:#0f172a; line-height:1.45; }
                .mnt-ot-obs { margin:0; font-size:.78rem; color:#334155; line-height:1.5; }
                .mnt-ot-meta {
                    display:flex; flex-wrap:wrap; gap:.22rem .65rem;
                    padding:.6rem 1rem; font-size:.72rem; color:#64748b;
                    border-bottom:1px solid #f8fafc;
                }
                .mnt-ot-meta span { display:flex; align-items:center; gap:.25rem; }
                .mnt-ot-foot {
                    display:flex; align-items:center; gap:.4rem; flex-wrap:wrap;
                    padding:.6rem 1rem;
                }

                /* Spinner */
                .mnt-spin {
                    width:28px; height:28px; border-radius:50%;
                    border:3px solid #fde8e8; border-top-color:#c81e22;
                    animation:mspin .75s linear infinite; display:inline-block;
                }
                @keyframes mspin { to { transform:rotate(360deg); } }
            `}</style>

            {/* ── Header ── */}
            <div className="mnt-header">
                <Link to={volverUrl} className="mnt-back">
                    <i className="bi bi-arrow-left"></i> Volver
                </Link>
                <div>
                    <h1 className="mnt-title">Mantenimiento</h1>
                    <p className="mnt-subtitle">{codigo || `Activo #${idactivo}`}</p>
                    {placa && (
                        <span className="mnt-placa">
                            <i className="bi bi-truck"></i>{placa}
                        </span>
                    )}
                </div>
            </div>

            {/* ── Top grid ── */}
            <div className="mnt-grid">

                {/* Datos de la unidad */}
                <div className="mnt-card">
                    <div className="mnt-card-hdr">
                        <div className="mnt-card-icon" style={{ background:'#fdf2f2' }}>
                            <i className="bi bi-truck" style={{ color:'#c81e22', fontSize:'.95rem' }}></i>
                        </div>
                        <span className="mnt-card-title">Datos de la unidad</span>
                    </div>
                    <div className="mnt-card-body">
                        {resumen === undefined ? (
                            <CardSpin />
                        ) : !unidad ? (
                            <EmptyState icon="bi-truck" msg="Sin datos disponibles para esta unidad." />
                        ) : (
                            <>
                                <InfoRow lbl="Placa"   val={unidad.idplaca || '—'} />
                                {unidad.cmarca       && <InfoRow lbl="Marca"          val={unidad.cmarca} />}
                                {unidad.cmodelo      && <InfoRow lbl="Modelo"         val={unidad.cmodelo} />}
                                {unidad.canio       && <InfoRow lbl="Año"            val={unidad.canio} />}
                                {unidad.ccuenta       && <InfoRow lbl="Cuenta"          val={unidad.ccuenta} />}
                                {unidad.ccontrato        && <InfoRow lbl="Contrato"          val={unidad.ccontrato} />}
                            </>
                        )}
                    </div>
                </div>

                {/* Siguiente mantenimiento preventivo */}
                <div className="mnt-card">
                    <div className="mnt-card-hdr">
                        <div className="mnt-card-icon" style={{ background:'#eff6ff' }}>
                            <i className="bi bi-calendar-check" style={{ color:'#1d4ed8', fontSize:'.95rem' }}></i>
                        </div>
                        <span className="mnt-card-title">Siguiente mantenimiento preventivo</span>
                    </div>
                    <div className="mnt-card-body">
                        {resumen === undefined ? (
                            <CardSpin />
                        ) : !resumen || resumen.encontrado === false ? (
                            <EmptyState icon="bi-calendar-x" msg="Sin información de mantenimiento preventivo." />
                        ) : resumen.ntipounidad === 2 ? (() => {
                            const rest   = resumen.nkmprogramado - resumen.nkm;
                            const status = statusFromKm(rest, resumen.ntolerancia);
                            const col    = STATUS[status].color;
                            return (
                                <>
                                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'.75rem' }}>
                                        <span className="mnt-section-lbl">Remolcador</span>
                                        <StatusBadge status={status} />
                                    </div>
                                    <MetricBlock value={formatKm(rest)} label="km restantes" color={col} />
                                    <InfoRow lbl="Km actual"      val={formatKm(resumen.nkm)} />
                                    <InfoRow lbl="Fecha Km"   val={formatFechaTs(resumen.dfechakm)} />
                                    <InfoRow lbl="Km programado"  val={formatKm(resumen.nkmprogramado)} />
                                    {resumen.ntolerancia != null && (
                                        <InfoRow lbl="Tolerancia" val={formatKm(resumen.ntolerancia)} valStyle={{ color:'#64748b', fontWeight:400 }} />
                                    )}
                                    <InfoRow lbl="Fecha estimada" val={formatFechaTs(resumen.dfechaestimada)} />
                                    <InfoRow lbl="Estado"         val={resumen.bprogramado ? 'Programado' : 'No programado'} />
                                </>
                            );
                        })() : resumen.ntipounidad === 1 ? (() => {
                            const dias   = calcDias(resumen.dfechaestimada);
                            const status = statusFromDias(dias, resumen.ntolerancia);
                            const col    = status ? STATUS[status].color : '#64748b';
                            return (
                                <>
                                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'.75rem' }}>
                                        <span className="mnt-section-lbl">Semirremolque</span>
                                        <StatusBadge status={status} />
                                    </div>
                                    <MetricBlock value={formatDias(dias)} label="para el próximo servicio" color={col} />
                                    <InfoRow lbl="Último servicio"  val={formatFechaTs(resumen.dotfecha)} />
                                    <InfoRow lbl="Fecha programada" val={formatFechaTs(resumen.dfechaestimada)} />
                                    {resumen.ntolerancia != null && (
                                        <InfoRow lbl="Tolerancia" val={`${resumen.ntolerancia} día${resumen.ntolerancia !== 1 ? 's' : ''}`} valStyle={{ color:'#64748b', fontWeight:400 }} />
                                    )}
                                    <InfoRow lbl="Estado" val={resumen.bprogramado ? 'Programado' : 'No programado'} />
                                </>
                            );
                        })() : resumen.ntipounidad === 3 ? (() => {
                            const dias   = calcDias(resumen.dfechaprogramada);
                            const status = statusFromDias(dias, resumen.ntolerancia);
                            const col    = status ? STATUS[status].color : '#64748b';
                            return (
                                <>
                                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'.75rem' }}>
                                        <span className="mnt-section-lbl">Modular</span>
                                        <StatusBadge status={status} />
                                    </div>
                                    <MetricBlock value={formatDias(dias)} label="para el próximo servicio" color={col} />
                                    <InfoRow lbl="Último servicio"  val={formatFechaTs(resumen.dotfecha)} />
                                    <InfoRow lbl="Fecha programada" val={formatFechaTs(resumen.dfechaprogramada)} />
                                    {resumen.ntolerancia != null && (
                                        <InfoRow lbl="Tolerancia" val={`${resumen.ntolerancia} día${resumen.ntolerancia !== 1 ? 's' : ''}`} valStyle={{ color:'#64748b', fontWeight:400 }} />
                                    )}
                                    <InfoRow lbl="Estado" val={resumen.bprogramado ? 'Programado' : 'No programado'} />
                                </>
                            );
                        })() : (
                            <EmptyState icon="bi-question-circle" msg="Tipo de unidad no reconocido." />
                        )}
                    </div>
                </div>
            </div>

            {/* ── Historial ── */}
            <div className="mnt-card">
                <div className="mnt-card-hdr">
                    <div className="mnt-card-icon" style={{ background:'#f0fdf4' }}>
                        <i className="bi bi-clock-history" style={{ color:'#15803d', fontSize:'.95rem' }}></i>
                    </div>
                    <span className="mnt-card-title">Historial de mantenimiento</span>
                    {Array.isArray(historial) && (
                        <span style={{ marginLeft:'auto', background:'#f1f5f9', color:'#475569', fontSize:'.72rem', fontWeight:700, padding:'.2rem .65rem', borderRadius:100 }}>
                            Ultimos {historial.length} registro{historial.length !== 1 ? 's' : ''}
                        </span>
                    )}
                </div>
                <div className="mnt-card-body">
                    {historial === undefined ? (
                        <CardSpin />
                    ) : historial === null ? (
                        <EmptyState icon="bi-wifi-off" msg="No se pudo cargar el historial." />
                    ) : historial.length === 0 ? (
                        <EmptyState icon="bi-inbox" msg="Sin registros de mantenimiento para esta unidad." />
                    ) : (
                        <div className="mnt-timeline">
                            <div className="mnt-tl-line"></div>
                            {historial.map(ot => {
                                const tc = tipoClass(ot.ctipo);
                                const eb = estadoCfg(ot.cestado);
                                return (
                                    <div key={ot.id} className="mnt-tl-item">
                                        
                                        <div className="mnt-ot">

                                            {/* ── Encabezado: OT + tipo + fecha ── */}
                                            <div className="mnt-ot-hdr">
                                                <div className="mnt-ot-hdr-left">
                                                    <span className="mnt-ot-id-num">OT #{ot.id}</span>
                                                    <div className="mnt-ot-badges">
                                                        <span className={`mnt-badge ${tc === 'correctivo' ? 'mnt-badge-corr' : 'mnt-badge-prev'}`}>
                                                            <i className={`bi ${tipoIcon(ot.ctipo)}`} style={{ marginRight:'.25rem', fontSize:'.6rem' }}></i>
                                                            {ot.ctipo}
                                                        </span>
                                                        {ot.bbacklog && <span className="mnt-badge mnt-badge-back">Backlog</span>}
                                                    </div>
                                                </div>
                                                <div className="mnt-ot-fecha-hdr">
                                                    <i className="bi bi-calendar2-check" style={{ color:'#64748b', fontSize:'.72rem' }}></i>
                                                    {formatFechaTs(ot.dfecha)}
                                                </div>
                                            </div>

                                            {/* ── Actividad y observaciones ── */}
                                            {(ot.cactividad || ot.cobservaciones) && (
                                                <div className="mnt-ot-body">
                                                    {ot.cactividad    && <p className="mnt-ot-act">{ot.cactividad}</p>}
                                                    {ot.cobservaciones && <p className="mnt-ot-obs">{ot.cobservaciones}</p>}
                                                </div>
                                            )}

                                            {/* ── Metadatos ── */}
                                            {(ot.taller || ot.supervisor || ot.cusuario || ot.ccuenta || ot.dias > 0) && (
                                                <div className="mnt-ot-meta">
                                                    {ot.taller     && <span><i className="bi bi-building"></i>Taller: {ot.taller}</span>}
                                                    {ot.supervisor && <span><i className="bi bi-person-badge"></i>Supervisor: {ot.supervisor}</span>}
                                                    
                                                    {ot.ccuenta    && <span><i className="bi bi-briefcase"></i>Cuenta: {ot.ccuenta}</span>}
                                                   
                                                </div>
                                            )}

                                            {/* ── Estado ── */}
                                            <div className="mnt-ot-foot">
                                                {ot.cestado && <span className="mnt-badge" style={{ background:eb.bg, color:eb.color }}>{ot.cestado}</span>}
                                                {ot.cestadoprecierre && (
                                                    <span className="mnt-badge" style={{ background:'#fef9c3', color:'#b45309', border:'1px solid #fde68a' }}>{ot.cestadoprecierre}</span>
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
